<template>
  <div
    class="badge"
    :class="{
      [`badge_${color}`]: true,
      badge_bordered: bordered,
      badge_muted: muted,
      badge_rounded: rounded,
      badge_contrast: contrast,
    }"
  >
    <slot />
  </div>
</template>

<script>
  export default {
    name: 'Badge',
    props: {
      /**
       * Color of the badge
       */
      color: {
        type: String,
        default: 'blue',
        validator: (color) =>
          [
            'blue',
            'warning',
            'light-blue',
            'white',
            'dark-green',
            'green',
            'light-green',
            'dark-grey',
            'grey',
            'light-grey',
            'orange',
            'light-red',
            'danger',
            'accent',
            'grey-black',
          ].includes(color),
      },
      /**
       * Set border of the badge.
       */
      bordered: {
        type: Boolean,
        default: false,
      },
      /**
       * Is the badge muted?
       */
      muted: {
        type: Boolean,
        default: false,
      },
      rounded: {
        type: Boolean,
        default: false,
      },
      contrast: {
        type: Boolean,
        default: false,
      },
    },
  };
</script>
<style scoped lang="scss">
  @import 'src/styles/colors';

  .badge {
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 4px;
    color: #04080e;
    line-height: 20px;
    font-size: 14px;
    padding: 0 8px;
    width: fit-content;
    font-weight: 500;
    height: fit-content;
    white-space: nowrap;

    &_rounded {
      border-radius: 14px;
    }

    &_blue {
      background-color: $primary500;
      color: white;
    }

    &_warning {
      background-color: $warning100;
    }

    &_light-blue {
      background-color: $semantic-info-surface;
      //color: $text-accent;
    }

    &_white {
      background-color: white;
      color: $grey500;
    }

    &_dark-green {
      background-color: $semantic-success;
    }

    &_green {
      background-color: $success100;
    }

    &_light-green {
      background-color: $semantic-success-surface;
    }

    &_dark-grey {
      background-color: $grey700;
      color: white;
    }

    &_grey {
      background-color: $surface3;
      color: $text-secondary;
    }

    &_grey-black {
      background-color: $surface3;
    }

    &_light-grey {
      background-color: $primary50;
    }

    &_orange {
      background-color: #fff3d8;
    }

    &_bordered {
      border: 1px solid $grey200;
    }

    &_muted {
      color: $grey500;
    }

    &_light-red {
      background-color: $danger100;
    }

    &_accent {
      background-color: $accent1;
      color: white;
    }

    &_danger {
      background-color: $danger500;
      color: white;
    }
    &_contrast {
      color: $text-primary !important;
    }
  }
</style>
